import { render, staticRenderFns } from "./WorkerDetailsNavbar.vue?vue&type=template&id=2c47cafb&scoped=true&"
import script from "./WorkerDetailsNavbar.vue?vue&type=script&lang=js&"
export * from "./WorkerDetailsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDetailsNavbar.vue?vue&type=style&index=0&id=2c47cafb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47cafb",
  null
  
)

export default component.exports